<template>
    <div>
        <div class="simple-form flex col-4">
            <div class="form-group center">
                <div class="form-label">
                    <label>职责权限名称</label>
                </div>
                <div class="form-value">
                    <span>{{ tplRole.confName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>目标岗位名称</label>
                </div>
                <div class="form-value">
                    <span>{{ tplRole.realName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>业务单元类型</label>
                </div>
                <div class="form-value">
                    <span>{{ bizUnitTypeMap[tplRole.bizUnitType] || '' }}</span>
                </div>
            </div>
            <!--            <div class="form-group center">-->
            <!--                <div class="form-label">-->
            <!--                    <label>是否门店专用</label>-->
            <!--                </div>-->
            <!--                <div class="form-value">-->
            <!--                    <span>{{ tplRole.shopFlag ? '是' : '否' }}</span>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--            <div class="form-group center" v-if="!tplRole.shopFlag">-->
            <!--                <div class="form-label">-->
            <!--                    <label>适用级别</label>-->
            <!--                </div>-->
            <!--                <div class="form-value">-->
            <!--                    <span v-if="tplRole.comLevel1">一级业务单元</span>-->
            <!--                    <span v-if="tplRole.comLevel2"><span v-if="tplRole.comLevel1">，</span>二级业务单元</span>-->
            <!--                    <span v-if="tplRole.comLevel3"><span v-if="tplRole.comLevel1 || tplRole.comLevel2">，</span>三级业务单元</span>-->
            <!--                    <span v-if="tplRole.comLevel4"><span v-if="tplRole.comLevel1 || tplRole.comLevel2 || tplRole.comLevel3">，</span>四级业务单元</span>-->
            <!--                </div>-->
            <!--            </div>-->
            <div class="form-group center">
                <div class="form-label">
                    <label>移动端角色</label>
                </div>
                <div class="form-value">
                    <span>{{ tplRole.mobAppRoleName }}</span>
                </div>
            </div>
        </div>
        <div class="simple-row clearfix" v-if="checkActionPerm('bath_role_tpl') && comRoleIds.length > 0">
            <div class="right">
                <button type="button" class="swb-btn swb-btn-small" @click="tplComRoleDlg()">批量更换职责权限</button>
            </div>
        </div>
        <div class="mult-table">
            <div class="table-tr th">
                <div class="table-td align-left" style="border-right: 1px solid #ddd; border-bottom: 1px solid #ddd;">
                    <span>机构名称</span>
                </div>
                <div class="table-td">
                    <div class="mult-table third">
                        <div class="table-tr">
                            <div class="table-td pl5">岗位名称</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-tr mult-table-bg" v-if="viewDtoList.length > 0" v-for="viewDto in viewDtoList">
                <div class="table-td align-left" style="border-right: 1px solid #ddd; border-bottom: 1px solid #ddd;">
                    <span>{{ viewDto.bizUnitName }} - {{ viewDto.comName }}</span>
                </div>
                <div class="table-td">
                    <div class="mult-table second">
                        <div class="table-tr" v-for="roleInfo in viewDto.roleList">
                            <div class="table-td pl5">
                                <span>{{ roleInfo.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="viewDtoList.length <= 0" class="font14 align-center font-gray2" style="margin-top: 100px;">暂无数据...</div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'
import { checkUserActionPerm } from '../index'

import retailerAuthxApi from '../../api/retailerAuthx'

import SwbMerchtTplRoleListSelect from './MerchtTplRoleListSelect'

Vue.regist(SwbMerchtTplRoleListSelect);

export default {
    name: 'swb-mercht-tpl-role-detail',
    desc: '岗位模版关联详情',
    props: ['tplId', 'tplRole', 'parentPath'],
    data: function () {
        return {
            bizUnitTypeMap: getEnumMap('bizUnitType', 'value2text'),
            viewDtoList: [],
            comRoleIds: []
        }
    },
    created: function () {
        this.getDtoList();
    },
    methods: {
        checkActionPerm: function (action) {
            return checkUserActionPerm(this.parentPath, action, null);
        },
        getDtoList() {
            let self = this;
            let postData = {};
            postData.srcTplId = this.tplId;
            let theLoading = MsgBox.loading();
            retailerAuthxApi.getRetailerComRoleBySrcTplId(postData, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    let dtoList = result.data;
                    self.handleData(dtoList);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        handleFirst(dto) {
            let viewDto = {};
            viewDto.comId = dto.comId;
            viewDto.comName = dto.comName;
            viewDto.comLevel = dto.comLevel;
            viewDto.bizUnitName = dto.bizUnitName;
            let roleInfo = {};
            roleInfo.id = dto.id;
            roleInfo.name = dto.name;
            roleInfo.mobAppRoleCode = dto.mobAppRoleCode;
            roleInfo.mobAppRoleName = dto.mobAppRoleName;
            viewDto.roleList = [roleInfo];
            //
            return viewDto;
        },
        handleData(dtoList) {
            let self = this;
            let viewDtoList = [];
            let comRoleIds = [];
            if(Utils.isNoB(dtoList) || dtoList.length <= 0) {
                Toast.show('暂无数据...');
                self.viewDtoList = viewDtoList;
                self.comRoleIds = comRoleIds;
                return;
            }
            //
            dtoList.forEach(function (dto) {
                if(viewDtoList.length == 0) {
                    let viewDto = self.handleFirst(dto);
                    viewDtoList.push(viewDto);
                } else {
                    let theViewDto = viewDtoList.find(function (viewDto) {
                        return viewDto.comId == dto.comId;
                    });
                    if(Utils.isNoB(theViewDto)) {
                        let viewDto = self.handleFirst(dto);
                        viewDtoList.push(viewDto);
                    } else {
                        let roleList = theViewDto.roleList;
                        let roleInfo = {};
                        roleInfo.id = dto.id;
                        roleInfo.name = dto.name;
                        roleInfo.mobAppRoleCode = dto.mobAppRoleCode;
                        roleInfo.mobAppRoleName = dto.mobAppRoleName;
                        roleList.push(roleInfo);
                        theViewDto.roleList = roleList;
                    }
                }
                comRoleIds.push(dto.id);
            });
            self.viewDtoList = viewDtoList;
            self.comRoleIds = comRoleIds;
        },
        tplComRoleDlg() {
            let self = this;
            let tplRole = this.tplRole;
            //
            let filter = {};
            filter.shopFlag = tplRole.shopFlag;
            filter.comLevel1 = tplRole.comLevel1;
            filter.comLevel2 = tplRole.comLevel2;
            filter.comLevel3 = tplRole.comLevel3;
            filter.comLevel4 = tplRole.comLevel4;
            //
            let theDlg = Vue.$showDialog({
                title: '职责权限 - 选择',
                width: 1200,
                height: 800,
                showCloseBtn: true,
                template: '<div>' +
                    '<swb-mercht-tpl-role-list-select :filter="filter" :radioFlag="true" ref="swb_tpl_com_role_list_select"></swb-mercht-tpl-role-list-select>' +
                    '</div>',
                data: {
                    filter: filter
                },
                methods: {},
                okClicked: function () {
                    let result = this.$refs.swb_tpl_com_role_list_select.getDlgResult() || {};
                    if(result.type == 'info') {
                        let tpl = result.data;
                        if(tplRole.id == tpl.id) {
                            self.$message.warning('请选择要更换的职责权限，当前职责权限已是【' + tplRole.confName + '】');
                        } else {
                            theDlg.close();
                            self.updateRoleContactTpl(tpl.id);
                        }
                    } else {
                        Toast.show(result.message);
                    }
                    return false;
                }
            });
        },
        updateRoleContactTpl(newTplRoleId) {
            let self = this;
            let tplRole = this.tplRole;
            let postData = {};
            postData.oldTplRoleId = tplRole.id;
            postData.newTplRoleId = newTplRoleId;
            postData.comRoleIds = self.comRoleIds;
            //
            let theLoading = MsgBox.loading();
            retailerAuthxApi.updateRetailerComRoleContactTpl(postData, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    self.getDtoList();
                } else {
                    MsgBox.warning(result.message);
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/authx/MerchtTplRoleDetail.vue